import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueWaypoint from 'vue-waypoint'
import VueNumber from 'vue-number-animation'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueEllipseProgress from 'vue-ellipse-progress'
import VCalendar from 'v-calendar';
import VueValidate from 'vuelidate'
import VueGtag from "vue-gtag";

Vue.use(VueWaypoint)
Vue.use(VueNumber)
Vue.use(VueAxios, axios)
Vue.use(VueEllipseProgress)
Vue.use(VCalendar, {
  componentPrefix: 'vc',             
});
Vue.use(VueValidate)

Vue.use(VueGtag, {
  config: { id: "GTM-T5BK74Z" }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  beforeCreate() { this.$store.commit('initialiseStore');},
  render: h => h(App)
}).$mount('#app')
